var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconVideoOff = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_742_251)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.49186 3.90607L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L23.7071 22.2929C24.0976 22.6834 24.0976 23.3166 23.7071 23.7071C23.3166 24.0976 22.6834 24.0976 22.2929 23.7071L17.1638 18.578C16.6179 19.1463 15.8502 19.5 15 19.5H4C2.34315 19.5 1 18.1569 1 16.5V6.5C1 5.39294 1.59965 4.42594 2.49186 3.90607ZM4.08579 5.5H4C3.44772 5.5 3 5.94772 3 6.5V16.5C3 17.0523 3.44772 17.5 4 17.5H15C15.298 17.5 15.5655 17.3697 15.7487 17.1629L4.08579 5.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 6.88583L17.5611 9.21667C16.897 9.66673 16 9.19105 16 8.38889V6.5C16 5.94772 15.5523 5.5 15 5.5H8.62132L6.62132 3.5H15C16.6569 3.5 18 4.84315 18 6.50306L21.4389 4.67222C22.103 4.22216 23 4.69783 23 5.5V16.5C23 18 21 18 21 16.5V6.88583Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_742_251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconVideoOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconVideoOff.1407a09f639abc37bc5d8f66ad9b3c42.svg";